/* ==========================================================
   CART UPSELL - "Agrega 1 mas y ahorra $299"
   - Detecta quantidade no carrinho
   - Mostra aviso quando carrinho tem 1 item só
   ========================================================== */
(function () {
  'use strict';

  var TARGET_QTY = 2;
  var SAVING_TEXT = '$299 MXN';
  var BANNER_ID = 'bs-cart-upsell';

  function isCartPage() {
    return /^\/cart\/?$/.test(window.location.pathname);
  }

  function isCheckoutPage() {
    return /\/checkouts?\//.test(window.location.pathname);
  }

  function fetchCartCount() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) { return data ? data.item_count : 0; })
      .catch(function () { return 0; });
  }

  function ensureBanner() {
    var b = document.getElementById(BANNER_ID);
    if (b) return b;
    b = document.createElement('div');
    b.id = BANNER_ID;
    b.className = 'bs-cart-upsell';
    b.setAttribute('hidden', '');
    b.innerHTML =
      '<div class="bs-cart-upsell__inner">' +
        '<span class="bs-cart-upsell__icon">💕</span>' +
        '<div class="bs-cart-upsell__msg">' +
          '<strong>¡Casi lo logras!</strong> ' +
          'Agrega <strong>1 bikini más</strong> a tu carrito y ahorra <strong>' + SAVING_TEXT + '</strong> automáticamente. ' +
        '</div>' +
        '<a href="/collections/all" class="bs-cart-upsell__btn">Agregar otro</a>' +
        '<button type="button" class="bs-cart-upsell__close" aria-label="Cerrar">×</button>' +
      '</div>';
    document.body.appendChild(b);
    b.querySelector('.bs-cart-upsell__close').addEventListener('click', function () {
      b.setAttribute('hidden', '');
      sessionStorage.setItem('bsCartUpsellDismissed', '1');
    });
    return b;
  }

  function showBanner() {
    if (sessionStorage.getItem('bsCartUpsellDismissed') === '1') return;
    var b = ensureBanner();
    b.removeAttribute('hidden');
    void b.offsetHeight;
    b.classList.add('is-open');
  }

  function hideBanner() {
    var b = document.getElementById(BANNER_ID);
    if (!b) return;
    b.classList.remove('is-open');
    setTimeout(function () { b.setAttribute('hidden', ''); }, 250);
  }

  function check() {
    if (isCheckoutPage()) return; // não aparece no checkout
    fetchCartCount().then(function (count) {
      if (count === 1) showBanner();
      else hideBanner();
    });
  }

  // Verifica periodicamente e em momentos chave
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', check);
  } else {
    check();
  }
  [800, 2500].forEach(function (ms) { setTimeout(check, ms); });

  // Reverifica quando a página volta a ficar visível (cliente abre/fecha aba)
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) check();
  });

  // Reverifica quando outro script adiciona algo ao carrinho
  var originalFetch = window.fetch;
  if (originalFetch) {
    window.fetch = function () {
      var args = arguments;
      var url = args[0];
      var result = originalFetch.apply(this, args);
      if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)) {
        result.then(function () { setTimeout(check, 200); }).catch(function () {});
      }
      return result;
    };
  }
})();
